export const AUTH_CHANNEL = 'auth';

export enum AUTH_STATE {
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  SIGNED_IN = 'signedIn',
  FORGOT_PASSWORD = 'forgotPassword',
}

export enum AUTH_EVENT {
  SIGN_IN = 'signIn',
  SIGN_UP = 'signUp',
  SIGN_OUT = 'signOut',
}

export const FIRSTNAME_FIELD = 'custom:firstname';
export const LASTNAME_FIELD = 'custom:lastname';
export const EMAIL_FIELD = 'email';
export const USERNAME_FIELD = 'username';
export const PASSWORD_FIELD = 'password';
export const STRIPE_ID_FIELD = 'custom:stripeId';
export const FREE_TRIAL_END_FIELD = 'custom:freeTrialEnd';
